<script setup>
import {useFlowStore} from "../../Registration/stores/flowStore";
import {useBookingStore} from "../../Registration/stores/bookingStore";
import {useSettingsManager} from "../../Registration/stores/settingsManagerStore";

const {settings} = useSettingsManager();
const flow = useFlowStore()
const booking = useBookingStore();
const confirm = ()=>{
    flow.participationStatusTransition('confirmed')
}
const decline = async ()=>{
    await booking.submit('cancelled');
    flow.participationStatusTransition('declined')
}

</script>

<template>
    <div
        class="registration-participation-steps text-center flex items-center justify-center border border-[#E6E7EB] py-10">
        <div class="registration-participation-steps-inner">
            <div class="registration-participation-message mb-5">
                <h2 class="sr-only" v-html="settings?.messages?.participation"></h2>
                <div class="text-content" v-html="settings?.messages?.participation" aria-live="polite"></div>
            </div>
            <div class="registration-participation-actions flex flex-col md:flex-row items-center justify-center gap-5"
                 role="group"
                 aria-label="Participation response options"
            >
                <div class="registration-participation-action">
                    <button
                        type="button"
                        class="btn btn-confirm"
                        @click="confirm"
                        v-html="settings?.messages?.participationButtonConfirm"
                        aria-label="Confirm participation">
                    </button>
                </div>
                <div class="registration-participation-action">
                    <button
                        type="button"
                        class="btn btn-decline"
                        @click="decline"
                        v-html="settings?.messages?.participationButtonDecline"
                        aria-label="Decline participation"
                    ></button>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>

</style>
